export default {
  issueTypes: [],
  projectStatuses: [],
  urgencyLevel: [],
  municipalities: [],
  fiscalYears: [
    {
      name: "",
      title_en: "",
      title_ne: ""
    }
  ],
  loading: true,
  projectBudgetProgramTypes: {},
  projectBudgetProgramSubTypes: {},
};



// WEBPACK FOOTER //
// ./src/infraMonitor/staticData/initialState.js